import {
  getMetricColor,
  getMetricColorForMetric,
  getMetricTextColorClass,
} from "@/metrics/metric-display"
import clsx from "clsx"

import type {
  MetricRecordData,
  TargetCondition,
} from "@/types/metrics/contracts"
import type { RunMetricOutput } from "@/types/RunMetricOutput"

export const SingleFloat = ({
  mo,
  units,
  formatFn = (v: number) => Number(v).toFixed(2),
  targetCondition,
  metric,
}: {
  mo: RunMetricOutput
  units: string
  formatFn?: (value: number) => string
  targetCondition?: TargetCondition
  metric?: MetricRecordData
}) => {
  const value = mo.float_value != null ? Number(mo.float_value) : null
  const color =
    value !== null
      ? metric
        ? getMetricColorForMetric(value, metric)
        : getMetricColor(value, targetCondition)
      : ("default" as const)
  const valueClassName = getMetricTextColorClass(color)
  return (
    <div className={clsx("text-2xl font-semibold", valueClassName)}>
      {value != null ? formatFn(value) : null}
      <span className="text-sm font-medium mx-1">{units}</span>
      {color === "danger" && <span className="sr-only">(below target)</span>}
    </div>
  )
}
